<template>
  <div class="narrow-container">
    <!-- <MetricsPeriodPickerDemo class="my-4" /> -->
    <AccountStatus class="mb-4" />
    <PendingWorkspaceInvites class="mb-4" />
    <GettingStarted class="mb-4" />
    <AnalyticsToday />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AccountStatus from "~/components/account-alerts/AccountStatus.vue";
import PendingWorkspaceInvites from "~/components/account-alerts/PendingWorkspaceInvites.vue";
import GettingStarted from "~/components/account-alerts/GettingStarted.vue";
import AnalyticsToday from "~/components/analytics/dashboards/Today.vue";
// import MetricsPeriodPickerDemo from "~/components/demos/MetricsPeriodPickerDemo.vue";

export default defineComponent({
  components: {
    AccountStatus,
    PendingWorkspaceInvites,
    GettingStarted,
    AnalyticsToday,
  },
  // components: {
  //   AccountStatus,
  //   GettingStarted,
  //   AnalyticsToday,
  //   MetricsPeriodPickerDemo,
  // },
});
</script>
